import type { FeatureInformation } from '@repo/api-codegen';

export function computeManageOptions(
	feature: FeatureInformation,
	resourceFiltersIdx?: number
) {
	const reducedPermissions = feature.permissions.map((p) => ({
		reducedName: p.name.replaceAll(feature.name, '').replaceAll('.', ''),
		description: p.description,
	}));

	if (reducedPermissions.length <= 2) {
		// Only read and write/update
		return [];
	}

	return reducedPermissions
		.filter((p) => p.reducedName !== 'Read')
		.filter((p) => {
			if (
				feature.name === 'Resources' &&
				typeof resourceFiltersIdx === 'number'
			) {
				return p.reducedName !== 'Create';
			} else if (
				feature.name === 'Resources' &&
				typeof resourceFiltersIdx !== 'number'
			) {
				return p.reducedName !== 'CreateInTeams';
			}

			return true;
		});
}
